module.exports = __webpack_public_path__ + "site-build/img/index_banner.04409a10.png";